import request from '@/utils/request'

//从环境变量获取biz服务的路径
const VUE_APP_BIZ_PATH = process.env.VUE_APP_BIZ_PATH
const VUE_APP_ROLE_PATH = process.env.VUE_APP_ROLE_PATH

//初始化state
const state = {
    
}
  
//定义getter
const getters = {

}

//定义同步的操作，即mutation
const mutations = {
    
}

//定义异步的操作，即action
const actions = {
    // 企业端-首页-监控覆盖情况统计
    async getMonitorCoverageStats() {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/enterprise/homePage/monitoringCoverageStats`
        const result = await request.get(url);
        //获取服务返回数据
        return result
    },
    // 企业端-首页-分类报警统计
    async getAlarmClassificationStats() {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/enterprise/homePage/alarmClassificationStats`
        const result = await request.get(url);
        //获取服务返回数据
        return result
    },
    // 企业端-首页-报警场景分布统计
    async getAlarmScenarioDistributionStats() {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/enterprise/homePage/alarmScenarioDistributionStats`
        const result = await request.get(url);
        //获取服务返回数据
        return result
    },
    // 地图上工厂的分布
    async getFactoryMap(){
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/enterprise/factory/findList`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 查询车间达标率一周列表--监控周报
    async getComplianceRateWeek(){
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/complianceRateWeekReport/weekStats`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 查询车间达标率一周列表--监控日报
    async getComplianceRateDaily(){
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/complianceRateDailyReport/dailyStats`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 查询过去7天管控得分--监控周报
    async getQualityWeekReport(){
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/qualityWeekReport/weekScore`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 查询全局管控得分--监控日报
    async getQualityDailyReport(){
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/qualityDailyReport/globalScore`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 查询上周管控得分--首页
    async getLastWeekScore(){
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/qualityWeekReport/lastWeekScore`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 查询当前管控得分--首页
    async getCurrWeekScore(){
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/qualityDailyReport/currScore`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 查询昨日管控得分--首页
    async getYesterdayScore(){
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/qualityDailyReport/yesterdayScore`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 用户统计--首页
    async getUserStats(){
        //发起request
        const url = `${VUE_APP_ROLE_PATH}/user/userStats`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 登录时间段统计--首页
    async getPeriodStats(){
        //发起request
        const url = `${VUE_APP_ROLE_PATH}/user/loginPeriodStats`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 高频使用用户列表--首页
    async getFreqUser(){
        //发起request
        const url = `${VUE_APP_ROLE_PATH}/user/freqUserList`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 查询周报摘要达标率综合统计
    async getCompStatsWeek(){
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/complianceRateWeekReport/compStats`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
     // 查询日报摘要达标率综合统计
    async getCompStatsDaily(){
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/complianceRateDailyReport/compStats`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 查询周报报摘要得分
    async getCompScoreWeek(){
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/qualityWeekReport/compScore`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 查询日报报摘要得分
    async getCompScoreDaily(){
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/qualityDailyReport/compScore`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 监控日报-获取报警相关数据
    async getDailyMonitoringAlarm(){
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/enterprise/monitor/getDailyMonitoringAlarmSummary`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 监控周报-获取报警相关数据
    async getWeekMonitoringAlarm(){
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/enterprise/monitor/getWeeklyMonitoringAlarmSummary`
        const result = await request.get(url);
        //获取服务返回数据
        return result 
    },
    // 查询日报表查看统计
    async getDailyStat() {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/reportViewStat/dailyStat`
        const result = await request.get(url);
        //获取服务返回数据
        return result
    },
    // 查询周报表查看统计
    async getWeekStat() {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/reportViewStat/weekStat`
        const result = await request.get(url);
        //获取服务返回数据
        return result
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }